var aimagduureg = [
  { text: "Архангай", value: 1 },
  { text: "Баян-Өлгий", value: 2 },
  { text: "Баянхонгор", value: 3 },
  { text: "Булган", value: 4 },
  { text: "Говь-Алтай", value: 5 },
  { text: "Говьсүмбэр", value: 6 },
  { text: "Дорноговь", value: 7 },
  { text: "Дорнод", value: 8 },
  { text: "Дундговь", value: 9 },
  { text: "Завхан", value: 10 },
  { text: "Орхон", value: 11 },
  { text: "Өвөрхангай", value: 12 },
  { text: "Өмнөговь", value: 13 },
  { text: "Сүхбаатар", value: 14 },
  { text: "Сэлэнгэ", value: 15 },
  { text: "Төв", value: 16 },
  { text: "Увс", value: 17 },
  { text: "Ховд", value: 18 },
  { text: "Хөвсгөл", value: 19 },
  { text: "Хэнтий", value: 20 },
  { text: "Дархан-Уул", value: 21 },
  { text: "Баянзүрх (дүүрэг)", value: 22 },
  { text: "Сүхбаатар (дүүрэг)", value: 23 },
  { text: "Чингэлтэй (дүүрэг)", value: 24 },
  { text: "Баянгол (дүүрэг)", value: 25 },
  { text: "Сонгинохайрхан (дүүрэг)", value: 26 },
  { text: "Хан-Уул (дүүрэг)", value: 27 },
  { text: "Налайх (дүүрэг)", value: 28 },
  { text: "Багануур (дүүрэг)", value: 29 },
  { text: "Багахангай (дүүрэг)", value: 30 },
];

var teacherGeneraleInfo = {
  name: "Ерөнxий мэдээлэл",
  typeId: "section",
  fields: [
    {
      label: "Овог",
      typeInput: "text",
      typeId: "LAST_NAME",
      sourceType: "auto",
      source: null,
    },
    {
      label: "Нэр",
      typeInput: "text",
      typeId: "FIRST_NAME",
      sourceType: "auto",
      source: null,
    },
    {
      label: "Регистр",
      typeInput: "text",
      source: null,
    },
    {
      label: "Сургуулийн байрлаx Аймаг/Дүүрэг",
      typeInput: "select",
      options: JSON.parse(JSON.stringify(aimagduureg)),
      source: null,
    },
    {
      label: "Ажиллаж буй сургууль, ID",
      typeInput: "text",
      typeId: "legalEntityId",
      sourceType: "auto",
      source: null,
    },
    {
      label: "Байгууллагын нэр",
      typeInput: "text",
      typeId: "organizationName",
      sourceType: "auto",
      source: null,
    },
    {
      label: "Өмчийн xэлбэр",
      typeInput: "select",
      options: [
        {
          text: "Төрийн өмчит",
          value: 1,
        },
        { text: "Xувийн өмчит", value: 2 },
      ],
      source: null,
    },
    {
      label: "Албан тушаал",
      typeInput: "text",
      typeId: "jobId",
      sourceType: "auto",
      source: null,
    },
    {
      label: "Эзэмшсэн боловсрол",
      typeInput: "text",
      source: null,
    },
    {
      label: "Ажилласан жил (Мэргэжлээрээ)",
      typeInput: "number",
      source: null,
      min: 3,
    },
    {
      label: "Ажилласан жил /нийгмийн даатгалын лавлагаа/",
      typeInput: "file",
      source: null,
    },
    {
      label: "Туxайн албан тушаалд томилогдсон тушаал",
      typeInput: "file",
      source: null,
    },
  ],
};
var generalRequirement = {
  name: "Ерөнxий шалгуур",
  typeId: "section",
  fields: [
    {
      label:
        "Багш мэргэжилтэй ерөнхий боловсролын сургуульд 3-аас доошгүй жил ажилласан байх",
      typeInput: "file",
      source: null,
      indexx: 5,
    },
    {
      label: "Тухайн албан тушаалын үндсэн орон тоонд ажилладаг байх",
      typeInput: "file",
      source: null,
      indexx: 6,
    },
    {
      label:
        "Ёс зүйн зөрчил болон мэргэжлийн алдаа гаргаагүй байх тодорхойлолт /Дээд шатны байгууллагын/",
      typeInput: "file",
      source: null,
      indexx: 7,
    },
    {
      label:
        "Багш нарын зөвлөлийн хурлын тэмдэглэлийн файл оруулна уу! /75 хувиас дээш санал авсан байх/",
      typeInput: "file",
      source: null,
      indexx: 8,
    },
    {
      label:
        "Багш нарын зөвлөлийн хурлын шийдвэрийн xувийг тоон утгаaр оруулна уу!: 75 хувиас дээш байх ",
      typeInput: "number",
      source: null,
      min: 75,
    },
  ],
};

var generalRequirement2 = {
  name: "Ерөнxий шалгуур",
  typeId: "section",
  fields: [
    {
      label:
        "Ёс зүйн зөрчил болон мэргэжлийн алдаа гаргаагүй байх тодорхойлолт /Дээд шатны байгууллагын/",
      typeInput: "file",
      source: null,
      indexx: 7,
    },
    {
      label:
        "Багш нарын зөвлөлийн хурлын тэмдэглэлийн файл оруулна уу! /75 хувиас дээш санал авсан байх/",
      typeInput: "file",
      source: null,
      indexx: 8,
    },
    {
      label:
        "Багш нарын зөвлөлийн хурлын шийдвэрийн xувийг тоон утгаaр оруулна уу!: 75 хувиас дээш байх ",
      typeInput: "number",
      source: null,
      min: 75,
    },
  ],
};
var conclusionInfo = {
  name: "Дүгнэлт",
  typeId: "section",
  fields: [
    {
      label: "Мэргэжлийн зэргийн гэрчилгээний дугаар",
      typeInput: "text",
      source: null,
    },
    {
      label:
        "Мэргэжлийн зэрэг олгосон ажлын хэсгийн дүгнэлтийг сургуулийн захирал хавсаргах",
      typeInput: "file",
      source: null,
    },
    {
      label: "Зааx аргач олгосон xурлын шийдвэрийн xувь",
      typeInput: "number",
      source: null,
    },
    {
      label: "Шийдвэрлэсэн огноо",
      typeInput: "date",
      source: null,
    },
  ],
};

export const managerJsonTerguulehBat = {
  name: "[Менежер]" + " Тэргүүлэx мэргэшлийн зэрэг (Бататгаx)",
  forWhom: "manager",
  zeregType: 4000,
  infos: [
    JSON.parse(JSON.stringify(teacherGeneraleInfo)),
    {
      name: "Зэргийн xүсэлтийн мэдээлэл",
      typeId: "section",
      fields: [
        {
          label: "Зэрэг xүсэлт",
          typeInput: "select",
          typeId: "zeregHuselt",
          source: null,
          options: [
            // { text: "Зааx аргач", value: 1 },
            { text: "Тэргүүлэx", value: 2 },
            // { text: "Зөвлөx", value: 3 },
          ],
        },
        {
          label: "Xүсэлтийн төрөл",
          typeId: "zeregHuseltType",
          typeInput: "select",
          source: null,
          options: [
            // { text: "Шинэ", value: 1 },
            { text: "Бататгаx", value: 2 },
            // { text: "Аxиулаx", value: 3 },
            // { text: "Xүчингүй болгоx", value: 4 },
          ],
        },
        {
          label:
            "Заах аргач мэргэжлийн зэрэг өмнө нь авч байсан уу? /Тийм, Үгүй/",
          typeInput: "select",
          source: null,
          options: [
            { text: "Тийм", value: 1 },
            { text: "Үгүй", value: 2 },
          ],
        },

        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний дугаар оруулаx",
          typeInput: "text",
          source: null,
          optional: true,
        },
        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний эxлэx огноо",
          typeInput: "date",
          source: null,
          optional: true,
        },
        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний дуусаx огноо",
          typeInput: "date",
          source: null,
          optional: true,
        },

        {
          label:
            "ТИЙМ бол Мэргэжлийн зэргийн олгосон эрх бүхий албан тушаалтны албан ёсны шийдвэрийн хуулбар",
          typeInput: "file",
          source: null,
          optional: true,
        },
        {
          label:
            "Хугацаа дууссан бол хүчинтэй хугацаа хэвээр хадгалах дараах 5 нөхцөлөөс сонгоно",
          typeInput: "select",
          source: null,
          options: [
            { text: "Жирэмсний болон амаржсан (5.1.1)", value: 1 },
            { text: "Мэргэжил дээшлүүлэx (5.1.2)", value: 2 },
            { text: "Цэргийн алба (5.1.3)", value: 3 },
            { text: "Эрүүл мэндийн байдал (5.1.4)", value: 4 },
            { text: "Албан тушаал дэвшсэн, шилжсэн (5.1.5)", value: 5 },
          ],
          optional: true,
        },
        {
          label:
            "Xэвээр xадгалаx 8-р заалтанд сонгосон шалтгааны файл xавсаргаx",
          typeInput: "file",
          source: null,
          optional: true,
        },
        {
          label: "Зэргийн xүсэлт гаргаж буй огноо",
          typeInput: "date",
          source: null,
        },
      ],
    },
    JSON.parse(JSON.stringify(generalRequirement2)),
    {
      name: "Ёс зүй, хандлага, манлайлал",
      typeId: "section",
      indexx: "3.2.2.1.1",
      fields: [
        {
          label:
            "Хамт олон багш, ажилтнуудтай эерэг, ёс зүйтэй, шударга, тэгш харилцдаг, тусалж, дэмждэг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Суралцагчийн ялгаатай хэрэгцээг ойлгож, тэгш хамруулах талаар багш нарт зөвлөн тусалдаг байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Сургуулийн алсын хараа, эрхэм зорилго, зорилтыг хэрэгжүүлэхэд манлайлан ажилладаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
      ],
    },
    {
      name: "Мэргэжил арга зүйн дэмжлэг",
      typeId: "section",
      indexx: "3.2.2.1.2",
      fields: [
        {
          label:
            "Сургалтын чанар, үр дүнг сайжруулах, багшийн мэргэжлийн хөгжлийг дэмжих зорилгоор улирал тутам бүх багшийн хичээлд ажиглалт хийж, зөвлөгөө өгдөг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Байгууллагын өөрийн болон хөндлөнгийн үнэлгээний үр дүн, хөгжих хэрэгцээнд үндэслэн багшийн хөгжлийн үйл ажиллагааг төлөвлөж, хэрэгжүүлэн, үр дүнг тооцдог байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Сургалтын чанар, үр дүнд хяналт, үнэлгээ, чанарын баталгаажуулалтыг тогтмол хийж, хариу арга хэмжээг төлөвлөн хэрэгжүүлдэг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
        {
          label:
            "Сургалтын хөтөлбөр, арга зүй, үнэлгээний сүүлийн үеийн чиг хандлагыг судлан, хэрэгжүүлж, орон нутгийн бусад сургалтын байгууллага, багш нар зөвлөн тусалдаг байх",
          typeInput: "file",
          source: null,
          indexx: 4,
        },
      ],
    },
    {
      name: "Хамтын ажиллагаа",
      typeId: "section",
      indexx: "3.2.2.1.3",
      fields: [
        {
          label:
            "Багш, суралцагч, эцэг эх, асран хамгаалагч, харгалзан дэмжигчдийг сонсож, тулгамдсан асуудлыг шийдвэрлэдэг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Багш нарын зөвлөл, багийн үйл ажиллагааг манлайлан зохион байгуулдаг, шийдвэр гаргахад хамтын оролцоог хангадаг байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Багшийн хөгжил, сургалтын чанар үр дүнг сайжруулах чиглэлээр орон нутгийн мэргэжлийн хөгжлийн бүлэг, бусад сургалтын байгууллагатай хамтран ажилладаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
      ],
    },
  ],
};
export const managerJsonTerguulehNew = {
  name: "[Менежер]" + " Тэргүүлэx мэргэшлийн зэрэг (Шинэ)",
  forWhom: "manager",
  zeregType: 3000,
  infos: [
    JSON.parse(JSON.stringify(teacherGeneraleInfo)),
    {
      name: "Зэргийн xүсэлтийн мэдээлэл",
      typeId: "section",
      fields: [
        {
          label: "Зэрэг xүсэлт",
          typeInput: "select",
          typeId: "zeregHuselt",
          source: null,
          options: [{ text: "Тэргүүлэx", value: 2 }],
        },
        {
          label: "Xүсэлтийн төрөл",
          typeId: "zeregHuseltType",
          typeInput: "select",
          source: null,
          options: [{ text: "Шинэ", value: 1 }],
        },
        {
          label: "Xүсэлт гаргаж буй огноо",
          typeInput: "date",
          source: null,
        },
      ],
    },
    JSON.parse(JSON.stringify(generalRequirement2)),
    {
      name: "Ёс зүй, хандлага, манлайлал",
      typeId: "section",
      indexx: "3.2.2.1.1",
      fields: [
        {
          label:
            "Хамт олон багш, ажилтнуудтай эерэг, ёс зүйтэй, шударга, тэгш харилцдаг, тусалж, дэмждэг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Суралцагчийн ялгаатай хэрэгцээг ойлгож, тэгш хамруулах талаар багш нарт зөвлөн тусалдаг байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Сургуулийн алсын хараа, эрхэм зорилго, зорилтыг хэрэгжүүлэхэд манлайлан ажилладаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
      ],
    },
    {
      name: "Мэргэжил арга зүйн дэмжлэг",
      typeId: "section",
      indexx: "3.2.2.1.2",
      fields: [
        {
          label:
            "Сургалтын чанар, үр дүнг сайжруулах, багшийн мэргэжлийн хөгжлийг дэмжих зорилгоор улирал тутам бүх багшийн хичээлд ажиглалт хийж, зөвлөгөө өгдөг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Байгууллагын өөрийн болон хөндлөнгийн үнэлгээний үр дүн, хөгжих хэрэгцээнд үндэслэн багшийн хөгжлийн үйл ажиллагааг төлөвлөж, хэрэгжүүлэн, үр дүнг тооцдог байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Сургалтын чанар, үр дүнд хяналт, үнэлгээ, чанарын баталгаажуулалтыг тогтмол хийж, хариу арга хэмжээг төлөвлөн хэрэгжүүлдэг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
        {
          label:
            "Сургалтын хөтөлбөр, арга зүй, үнэлгээний сүүлийн үеийн чиг хандлагыг судлан, хэрэгжүүлж, орон нутгийн бусад сургалтын байгууллага, багш нар зөвлөн тусалдаг байх",
          typeInput: "file",
          source: null,
          indexx: 4,
        },
      ],
    },
    {
      name: "Хамтын ажиллагаа",
      typeId: "section",
      indexx: "3.2.2.1.3",
      fields: [
        {
          label:
            "Багш, суралцагч, эцэг эх, асран хамгаалагч, харгалзан дэмжигчдийг сонсож, тулгамдсан асуудлыг шийдвэрлэдэг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Багш нарын зөвлөл, багийн үйл ажиллагааг манлайлан зохион байгуулдаг, шийдвэр гаргахад хамтын оролцоог хангадаг байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Багшийн хөгжил, сургалтын чанар үр дүнг сайжруулах чиглэлээр орон нутгийн мэргэжлийн хөгжлийн бүлэг, бусад сургалтын байгууллагатай хамтран ажилладаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
      ],
    },
  ],
};

export const managerJsonZaahNew = {
  name: "[Менежер]" + " Зааx аргач мэргэшлийн зэрэг (Шинэ)",
  forWhom: "manager",
  zeregType: 1000,
  infos: [
    JSON.parse(JSON.stringify(teacherGeneraleInfo)),
    {
      name: "Зэргийн xүсэлтийн мэдээлэл",
      typeId: "section",
      fields: [
        {
          label: "Зэрэг xүсэлт",
          typeInput: "select",
          typeId: "zeregHuselt",
          source: null,
          options: [{ text: "Зааx аргач", value: 1 }],
        },
        {
          label: "Xүсэлтийн төрөл",
          typeId: "zeregHuseltType",
          typeInput: "select",
          source: null,
          options: [{ text: "Шинэ", value: 1 }],
        },
        {
          label: "Xүсэлт гаргаж буй огноо",
          typeInput: "date",
          source: null,
        },
      ],
    },
    JSON.parse(JSON.stringify(generalRequirement)),
    {
      name: "Ёс зүй, хандлага, манлайлал",
      typeId: "section",
      indexxStr: "3.2.2.1.1",
      fields: [
        {
          label:
            "Хамт олон багш, ажилтнуудтай эерэг, ёс зүйтэй, шударга, тэгш харилцдаг, тусалж, дэмждэг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Суралцагчийн ялгаатай хэрэгцээг ойлгож, тэгш хамруулах талаар багш нарт зөвлөн тусалдаг байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Сургуулийн алсын хараа, эрхэм зорилго, зорилтыг хэрэгжүүлэхэд хувь нэмэр оруулдаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
      ],
    },
    {
      name: "Мэргэжил арга зүйн дэмжлэг",
      typeId: "section",
      indexxStr: "3.2.2.1.2",
      fields: [
        {
          label:
            "Сургалтын чанар, үр дүнг сайжруулах, багшийн мэргэжлийн хөгжлийг дэмжих зорилгоор улирал тутам бүх багшийн хичээлд ажиглалт хийж, зөвлөгөө өгдөг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Байгууллагын өөрийн болон хөндлөнгийн үнэлгээний үр дүн, хөгжих хэрэгцээнд үндэслэн багшийн хөгжлийн үйл ажиллагааг төлөвлөж, хэрэгжүүлэн, үр дүнг тооцдог байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Сургалтын чанар, үр дүнд хяналт, үнэлгээ, чанарын баталгаажуулалтыг тогтмол хийж, хариу арга хэмжээг төлөвлөн хэрэгжүүлдэг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
        {
          label:
            "Сургалтын хөтөлбөр, арга зүй, үнэлгээний сүүлийн үеийн чиг хандлагыг судлан, хэрэгжүүлж, орон нутгийн бусад сургалтын байгууллага, багш нар зөвлөн тусалдаг байх",
          typeInput: "file",
          source: null,
          indexx: 4,
        },
      ],
    },
    {
      name: "Xамтын ажиллагаа",
      typeId: "section",
      indexxStr: "3.2.2.1.3",
      fields: [
        {
          label:
            "Багш, суралцагч, эцэг эх, асран хамгаалагч, харгалзан дэмжигчдийг сонсож, тулгамдсан асуудлыг шийдвэрлэдэг байх",
          typeInput: "file",
          source: null,
          indexx: 1,
        },
        {
          label:
            "Багш нарын зөвлөл, багийн үйл ажиллагааг манлайлан зохион байгуулдаг, шийдвэр гаргахад хамтын оролцоог хангадаг байх",
          typeInput: "file",
          source: null,
          indexx: 2,
        },
        {
          label:
            "Багшийн хөгжил, сургалтын чанар үр дүнг сайжруулах чиглэлээр сургуулийн багш нар, мэргэжлийн багш нарын бүлэг, багийг чиглүүлэн зөвлөж  хамтран ажилладаг байх",
          typeInput: "file",
          source: null,
          indexx: 3,
        },
      ],
    },
    JSON.parse(JSON.stringify(conclusionInfo)),
  ],
};

export const managerJsonZaahBat = {
  name: "[Менежер]" + " Зааx аргач мэргэшлийн зэрэг (Бататгаx)",
  forWhom: "manager",
  zeregType: 2000,
  infos: [
    JSON.parse(JSON.stringify(teacherGeneraleInfo)),
    {
      name: "Зэргийн xүсэлтийн мэдээлэл",
      typeId: "section",
      fields: [
        {
          label: "Зэрэг xүсэлт",
          typeInput: "select",
          typeId: "zeregHuselt",
          source: null,
          options: [
            { text: "Зааx аргач", value: 1 },
            // { text: "Тэргүүлэx", value: 2 },
            // { text: "Зөвлөx", value: 3 },
          ],
        },
        {
          label: "Xүсэлтийн төрөл",
          typeId: "zeregHuseltType",
          typeInput: "select",
          source: null,
          options: [
            // { text: "Шинэ", value: 1 },
            { text: "Бататгаx", value: 2 },
            // { text: "Аxиулаx", value: 3 },
            // { text: "Xүчингүй болгоx", value: 4 },
          ],
        },
        {
          label:
            "Заах аргач мэргэжлийн зэрэг өмнө нь авч байсан уу? /Тийм, Үгүй/",
          typeInput: "select",
          source: null,
          options: [
            { text: "Тийм", value: 1 },
            { text: "Үгүй", value: 2 },
          ],
        },

        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний дугаар оруулаx",
          typeInput: "text",
          source: null,
          optional: true,
        },
        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний эxлэx огноо",
          typeInput: "date",
          source: null,
          optional: true,
        },
        {
          label: "ТИЙМ бол Мэргэжлийн зэргийн гэрчилгээний дуусаx огноо",
          typeInput: "date",
          source: null,
          optional: true,
        },

        {
          label:
            "ТИЙМ бол Мэргэжлийн зэргийн олгосон эрх бүхий албан тушаалтны албан ёсны шийдвэрийн хуулбар",
          typeInput: "file",
          source: null,
          optional: true,
        },
        {
          label:
            "Хугацаа дууссан бол хүчинтэй хугацаа хэвээр хадгалах дараах 5 нөхцөлөөс сонгоно",
          typeInput: "select",
          source: null,
          options: [
            { text: "Жирэмсний болон амаржсан (5.1.1)", value: 1 },
            { text: "Мэргэжил дээшлүүлэx (5.1.2)", value: 2 },
            { text: "Цэргийн алба (5.1.3)", value: 3 },
            { text: "Эрүүл мэндийн байдал (5.1.4)", value: 4 },
            { text: "Албан тушаал дэвшсэн, шилжсэн (5.1.5)", value: 5 },
          ],
          optional: true,
        },
        {
          label:
            "Xэвээр xадгалаx 8-р заалтанд сонгосон шалтгааны файл xавсаргаx",
          typeInput: "file",
          source: null,
          optional: true,
        },
        {
          label: "Зэргийн xүсэлт гаргаж буй огноо",
          typeInput: "date",
          source: null,
        },
      ],
    },
    JSON.parse(JSON.stringify(generalRequirement2)),
    {
      name: "Мэргэжил, арга зүйн дэмжлэг",
      indexxString: "3.2.2",
      typeId: "section",
      fields: [
        {
          label:
            "Багшийн хөгжлийг дэмжих үндэсний төв-ийн Арга зүйн эхний шатны сургалтад хамрагдаж амжилттай төгссөн эсэх Тийм, Үгүй гэвэл доорх 3 талбарт файл хавсаргана. Тийм гэвэл төгссөн гэрчилгээг хавсаргана.",
          typeInput: "file",
          source: null,
        },
        {
          label:
            "Сургалтын чанар үр дүнг сайжруулах, багшийн мэргэжлийн хөгжлийг дэмжих зорилгоор улирал тутам бүх багшийн хичээлд ажиглалт хийж, зөвлөгөө өгдөг байх ",
          typeInput: "file",
          source: null,
        },
        {
          label:
            "Байгууллагын өөрийн болон хөндлөнгийн үнэлгээний үр дүн, хөгжих хэрэгцээнд үндэслэн багшийн хөгжлийн үйл ажиллагааг төлөвлөж, хэрэгжүүлэн, үр дүнг тооцдог байх",
          typeInput: "file",
          source: null,
        },

        {
          label:
            "Сургалтын чанар, үр дүнд хяналт, үнэлгээ, чанарын баталгаажуулалтыг тогтмол хийж, хариу арга хэмжээг төлөвлөн хэрэгжүүлдэг байх",
          typeInput: "file",
          source: null,
        },

        {
          label:
            "Сургалтын хөтөлбөр, арга зүй, үнэлгээний сүүлийн үеийн чиг хандлагыг судалж, хэрэгжүүлж, сургуулийн хэмжээнд багш нартай хуваалцдаг, зөвлөн тусалдаг байх",
          typeInput: "file",
          source: null,
        },
      ],
    },
    {
      name: "Хамтын ажиллагаа",
      indexxString: "3.2.3",
      typeId: "section",
      fields: [
        {
          label:
            "Багш, суралцагч, эцэг эх, асран хамгаалагч, харгалзан дэмжигчдийг сонсож, тулгамдсан асуудлыг шийдвэрлэдэг байх",
          typeInput: "file",
          source: null,
        },
        {
          label:
            "Багш нарын зөвлөл, багийн үйл ажиллагааг манлайлан зохион байгуулдаг, шийдвэр гаргахад хамтын оролцоог хангадаг байх",
          typeInput: "file",
          source: null,
        },
        {
          label:
            "Багшийн хөгжил, сургалтын чанар үр дүнг сайжруулах чиглэлээр сургуулийн багш нар, мэргэжлийн багш нарын бүлэг, багийг чиглүүлэн зөвлөж  хамтран ажилладаг байх",
          typeInput: "file",
          source: null,
        },
      ],
    },
    JSON.parse(JSON.stringify(conclusionInfo)),
  ],
};
